import { Component, ChangeDetectorRef, ElementRef, Input, OnInit, ViewChild, AfterViewInit  } from '@angular/core';
import { Services } from '../helpers/Services';
// import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { BsModalService } from 'ngx-bootstrap/modal';
import { HttpClient } from '@angular/common/http';
// import { Router, ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';

import * as $ from 'jquery';

declare var gtag;
declare const fbq;


@Component({
  selector: 'app-payment-access-report',
  templateUrl: './payment-access-report.component.html',
  styleUrls: ['./payment-access-report.component.css']
})
export class PaymentAccessReportComponent implements OnInit,AfterViewInit {

  @ViewChild("graphCanvas") graphCanvas: ElementRef;
  ctx: CanvasRenderingContext2D;
  canvasGraphEl: HTMLCanvasElement;


  static httpClient: any;
  appservices: Services;
  apirequest: any[] = [];
  input: any;
  responsedata: any;
  dentalImages: any;
  defaultImage: string = "assets/images/carousel_loader.gif";


  widget_flow_type:any = '';
  payment_title:any = '';
  payment_sub_title:any = '';
  benefits:any = '';
  payment_amount:any = '';
  title_for_button:any = '';
  payment_button_text:any = '';
  payment_type:any = '';
  overall_score:any = '';
  OHRImage:any = '';
  OHRText:any = '';

  benefits_title:any = 'Get your personalised recommendations';
  benefits_sub_title:any = 'Visuals of AI annotated personalised results';
  benefits_one:any = '';
  benefits_two:any = '';
  benefits_three:any = '';

  report_id:any = '';
  created_date:any = '';
  app_details:any = ''; 
  rating_explanation:any = '';

  displayHeader: any = 'Oral Health Rating';
  
  meterClassName:string = '';
  imageContainer:string = 'visibility_none';

  get_contact_information_later:any = ''; 
  guest_user_id:any = '';

  ohr_flow:any; 
  show_benefits_div:boolean = false;
  selected_currency:any; 
  currency_symbol:any;
  right_border_line:string = 'right_border_line';

  localeString:any;
  practice_currency:any;

  countryLocaleString:string = 'en-AU';
  widget_token:any;
  availablePromocodes:any = '';
  promoCode:any = '';
  invalidPromocode:boolean = false;
  discount_type:any; 
  discount_price:any;
  payment_amount_before_discount:any;
  payment_amount_after_discount:any = '';
  discounted_amount:any = '';
  invalidPromocodeMsg:any = '';
  promocodeApplied:boolean = false;
  discount_symbol:any = '';
  promocodeId:any = '';
  greyText:string = 'grey-text disabled';

  promocodeBtnInput:string = 'promocode-btn'; 

  customQueryParams:any;

  constructor(private httpClient: HttpClient, private router: Router, private modalService: BsModalService,private _cd: ChangeDetectorRef,) {
    this.appservices = new Services;
  }
  ngAfterViewInit(): void {
    // console.log(" Hellow ");

    if ($(window).width() > 576) {       
      setTimeout(() => {
        if( $(".custom_height").length>0 && $(".right_border_line").length>0)
        {
          var border_line_height = $('.custom_height').find('.right_border_line:first').height();
          // console.log(" border_line_height " + border_line_height);
          $(".right_border_line").height(border_line_height);
        }
      }, 1000);
    }
  }
  slideConfig = {
    "slidesToShow": 1,
    "slidesToScroll": 1,
    "dots": true,
    "nextArrow": "<div class='nav-btn icon-right-arrow next-slide blue_color font_30'></div>",
    "prevArrow": "<div class='nav-btn icon-left-arrow prev-slide blue_color font_30'></div>",
    "infinite": false,
  };

  slickInit(e) {
    // console.log('slick initialized');
  }

  async ngOnInit() 
  {
    this.widget_token        = this.appservices.getSession("token", false);

    // console.log(this.apirequest);
    await this.getPromocodeList();


      if(!this.appservices.isEmpty(this.appservices.getSession("discount_price", false)))
      {
        this.payment_amount_before_discount = this.appservices.getSession("payment_amount_before_discount", false)
        this.appservices.setSession("payment_amount",this.payment_amount_before_discount, false);

        this.appservices.setSession("discount_price",'', false);

        this.appservices.setSession("discount_type",'', false);

        this.appservices.setSession("promocodeId",'', false);
        

      }  

    // console.log(" outer data : ");


    this.localeString = [
      {key:'SAR',value:'ar-SA'},
      {key:'BDT',value:'bn-BD'},
      {key:'INR',value:'en-IN'},
      {key:'CZK',value:'cs-CZ'},
      {key:'DKK',value:'da-DK'},   
      {key:'EUR',value:'de-DE'},
      {key:'AUD',value:'en-AU'},
      {key:'CAD',value:'en-CA'},
      {key:'CAD',value:'en-CA'},
      {key:'GBP',value:'en-GB'},
      {key:'NZD',value:'en-NZ'},
      {key:'USD',value:'en-US'},      
      {key:'ZAR',value:'en-ZA'},
      {key:'COP',value:'es-CO'},
      {key:'MXN',value:'es-MX'},
      {key:'JPY',value:'ja-JP'},  
      {key:'CNY',value:'zh-CN'},
      {key:'TRY',value:'tr-TR'},
      {key:'THB',value:'th-TH'},
      {key:'SEK',value:'sv-SE'}    
    ];

    setTimeout(() => {
      this.canvasGraphEl = this.graphCanvas.nativeElement;
      this.ctx = this.canvasGraphEl.getContext("2d"); 
      this.drawNewGraph();
      this.imageContainer = 'visibility_block';
    }, 1000);

    // console.log('sa_wg_payment_access');
    this.appservices.sendAnalyticsData(gtag, fbq, 'smilo_event', 'sa_wg_payment_access',true);

    this.app_details = JSON.parse(JSON.stringify(this.appservices.getSession("app_details", true)));
    // console.log(this.app_details);
    this.appservices.setSession("bannerTitleText",this.displayHeader,false);
    this.widget_flow_type = this.appservices.getSession("widget_flow_type", false);
    this.report_id           = this.appservices.getSession("ohr_unique_key", false);
    if(this.appservices.isEmpty(this.widget_flow_type)||this.appservices.isEmpty(this.report_id))
    {
      this.router.navigate(['get-started/'+this.appservices.getSession("token", false)]);
    }


    this.dentalImages = [
      { "url": 'assets/images/Slide1@2x.png', "title": "Healthy Teeth" },
      { "url": 'assets/images/Slide2@2x.png', "title": "Mild Decay" },
      { "url": 'assets/images/Slide3@2x.png', "title": "Moderate Decay" }
    ]

    this.widget_flow_type      = this.appservices.getSession("widget_flow_type", false);

    if(!this.appservices.isEmpty(this.appservices.getSession("payment_title", false)))
    {            
      this.payment_title         = this.appservices.getSession("payment_title", false);
    }
 
    if(!this.appservices.isEmpty(this.appservices.getSession("payment_sub_title", false)))
    {            
      this.payment_sub_title     = this.appservices.getSession("payment_sub_title", false);
    }    
    
    this.benefits              = this.appservices.getSession("benefits", false);
    this.payment_amount        = this.appservices.getSession("payment_amount", false);

    this.payment_amount_before_discount = this.payment_amount ;

    // if(this.payment_amount!='')
    // {       
    //   this.practice_currency = this.appservices.getSession("practice_currency", false);
      
    //   var index = this.localeString.findIndex(x => x.key === this.practice_currency); 
    //   if(index!=-1&&index!='')
    //   {
    //     this.countryLocaleString = this.localeString[index].value;
    //   }    
    //   this.payment_amount =  (parseFloat(this.payment_amount)).toLocaleString(this.countryLocaleString);
    // }
    
    this.title_for_button      = this.appservices.getSession("title_for_button", false);
    this.payment_button_text   = this.appservices.getSession("payment_button_text", false);
    this.payment_type          = this.appservices.getSession("payment_type", false);

    if(!this.appservices.isEmpty(this.appservices.getSession("benefits_title", false)))
    {            
      this.benefits_title   = this.appservices.getSession("benefits_title", false);
    }
 
    if(!this.appservices.isEmpty(this.appservices.getSession("benefits_sub_title", false)))
    {            
      this.benefits_sub_title   = this.appservices.getSession("benefits_sub_title", false);
    }  

    
    
    this.benefits_one   = this.appservices.getSession("benefits_one", false);
    this.benefits_two   = this.appservices.getSession("benefits_two", false);
    this.benefits_three   = this.appservices.getSession("benefits_three", false);

    if(this.benefits_two==''&&this.benefits_three=='')
    {
      this.right_border_line = "right_border_without_line";
    }

    this.overall_score = this.appservices.getSession("overall_score", false);     
    this.OHRImage = this.appservices.getSmileyImage(this.overall_score);
    this.OHRText = this.appservices.getSmileyText(this.overall_score);

    this.created_date = this.appservices.getSession("created_date", false);

    this.ohr_flow     =  this.appservices.getSession("ohr_flow", false);

   // console.log(" this.ohr_flow : " + this.ohr_flow + " this.widget_flow_type  " + this.widget_flow_type + " this.payment_type : " + this.payment_type);

    if(this.overall_score<=4)
    {
      this.rating_explanation = this.app_details.report_info_descriptions3;
    }

    if(this.overall_score>=5&&this.overall_score<=7)
    {
      this.rating_explanation = this.app_details.report_info_descriptions2;
    }
    
    if(this.overall_score>=8&&this.overall_score<=10)
    {
      this.rating_explanation = this.app_details.report_info_descriptions1; 
    }  
    
  this.get_contact_information_later = this.appservices.getSession("get_contact_information_later", false);                 
  this.guest_user_id                 = this.appservices.getSession("guest_user_id", false); 
  // this.selected_currency             = this.appservices.getSession("selected_currency",false);

  // if(this.selected_currency=='aud')
  // {
  //   this.currency_symbol = 'A$';
  // }
  // else if(this.selected_currency=='inr')
  // {
  //   this.currency_symbol = '₹';
  // }

  this.currency_symbol = this.appservices.getSession("practice_currency_symbol",false);
  

  // console.log(" this.selected_currency : " + this.selected_currency);

  }

  drawNewGraph() {

    var center = {
        "x": 115,
        "y": 115
    };
    var radius = 100;
    var quadrants = [{
            "angleStart": Math.PI * -0.5,
            "angleEnd": 0,
            "x1": center.x,
            "y1": center.y - radius,
            "x2": center.x + radius,
            "y2": center.y,
            "colorStops": [{
                    "stop": 0,
                    "color": "#ffc906"
                },
                {
                    "stop": 1,
                    "color": "red"
                }
            ]
        },
        {
            "angleStart": Math.PI,
            "angleEnd": Math.PI * 1.5,
            "x1": center.x - radius,
            "y1": center.y,
            "x2": center.x,
            "y2": center.y - radius,
            "colorStops": [{
                    "stop": 0,
                    "color": "green"
                },
                {
                    "stop": 1,
                    "color": "#ffc906"
                }
            ]
        }
    ];

    // Draw arc quadrants.
    for (var i = 0; i < quadrants.length; ++i) {
        var quad = quadrants[i];
        var grad = this.ctx.createLinearGradient(quad.x1, quad.y1, quad.x2, quad.y2);
        // Color stops.
        for (var j = 0; j < quad.colorStops.length; ++j) {
            var cs = quad.colorStops[j];
            grad.addColorStop(cs.stop, cs.color);
        }
        // Draw arc.
        this.ctx.beginPath();
        this.ctx.arc(center.x, center.y, radius, quad.angleStart, quad.angleEnd);
        this.ctx.strokeStyle = grad;
        this.ctx.lineWidth = 30;
        this.ctx.stroke();


        if(typeof(this.overall_score)==='string'&&(!this.appservices.isEmpty(this.overall_score)))
        {
          this.overall_score = Number(this.overall_score);          
        }
        if(this.overall_score<=4)
        {
          this.overall_score = 1; 
        }
        else if (this.overall_score >= 5 && this.overall_score <= 7)
        {
          this.overall_score = 5; 
        }
        else 
        {
          this.overall_score = 9;
        }
         

        // if()

        // this.overall_score = 1;
        var angle = (180 - (Math.floor(this.overall_score) * 18));
        this.meterClassName = "rotate" + angle;
        // var angle = 0;

        //   img = document.getElementById('container'); 
        //   angle = (angle + 18);
        //   img.className = "rotate" + angle;  

    }
}

  makePayment()
  {
    // console.log('sa_wg_payment_button_make_payment');
    this.appservices.sendAnalyticsData(gtag, fbq, 'smilo_event', 'sa_wg_payment_button_make_payment',true);

    
    if(!this.appservices.isEmpty(this.promocodeId))
    {
      this.appservices.setSession("payment_amount",this.payment_amount_after_discount, false);      
      this.appservices.setSession("payment_amount_before_discount",this.payment_amount_before_discount, false);      
      this.appservices.setSession("discount_price",this.discounted_amount, false);
      if(this.discount_type=='free')
      {
        this.appservices.setSession("discount_price",this.payment_amount_before_discount, false);
      }      
      this.appservices.setSession("discount_type",this.discount_type, false);      
      this.appservices.setSession("promocodeId",this.promocodeId, false);      
    }

    // console.log(" this.payment_amount :  " + this.payment_amount);
    if(this.payment_type==='stripe'&&this.payment_amount>0)
    {      
      this.router.navigate(['make-stripe-payment']);    
    }
    else 
    {
      this.appservices.setSession("payment_successful", 'true', false);
      
        this.customQueryParams = '';
      if(!this.appservices.isEmpty(this.promocodeId))
      {
        // this.customQueryParams = "?session_id="+Math.floor(Math.random() * 25654789454454);;

        this.router.navigate(['details', {session_id: Math.floor(Math.random() * 25654789454454)}]);


      } 
      this.router.navigate(['payment-oral-health-score-completed'+this.customQueryParams]);
    }

    // else if(this.payment_type===''&&this.appservices.isEmpty(this.get_contact_information_later))
    // {
    //   this.appservices.setSession("payment_successful", 'true', false);
    //   this.router.navigate(['payment-oral-health-score-completed']);
    // }
    // else if(!this.appservices.isEmpty(this.get_contact_information_later)&&this.get_contact_information_later=='yes')
    // {
    //   this.appservices.setSession("redirecting_url",'payment-oral-health-score-completed', false);
    //   this.router.navigate(['contact-information']);
    // }
  }

  show_benefits()
  {
    this.show_benefits_div = true;
  }

  applyPromo()
  {
    this.promocodeId  = '';
    this.discount_type = '';
    this.discount_price  = '';
    this.discounted_amount = '';
    this.promoCode = this.promoCode.trim();
    if(this.promoCode==='')
    {
      this.invalidPromocode = true;
      this.invalidPromocodeMsg = 'Promo code should not be empty';
      return false;
    }

    if(!this.invalidPromocode)
    {
      this.widget_token        = this.appservices.getSession("token", false);
      this.apirequest = [];
      this.apirequest["widget_token"] = this.widget_token;
      this.apirequest["promo_code"] = this.promoCode;
      this.apirequest["user_id"] = '';
      if(!this.appservices.isEmpty(this.appservices.getSession("user_id", false)))
      {
        this.apirequest["user_id"] = this.appservices.getSession("user_id", false);
      }

      // console.log(" this.apirequest[user_id] : " + this.apirequest["user_id"]);

      let report_input = this.appservices.generteJSONFromArray(this.apirequest);
      // console.log(this.apirequest);
      this.appservices.callJSONAPI(this.appservices.VALIDATE_PROMOCODE, report_input, 'post', this, '').subscribe(
        (data: any) => {
          // console.log(" data : " + data.status);
          if(!data.status)
          {       

            if(data.status_code=='2')
            {
              
            this.invalidPromocode = true;
            this.invalidPromocodeMsg = 'Promo code has been already used';
            return false; 
            }

            this.invalidPromocode = true;
            this.invalidPromocodeMsg = 'Invalid Promo code';
            return false; 
          }
          this.promocodeBtnInput = 'promocode-btn-applied';
          // console.log(" data.result[0].id " + data.result[0].id);
          this.promocodeId  = data.result[0].id;
          this.discount_type = data.result[0].discount_type; 
          this.discount_price  = data.result[0].discount_price;
          this.discounted_amount = this.discount_price;
          this.payment_amount  = parseFloat(this.payment_amount); 
          //this.discount_symbol   = '(- '+ this.discount_price+')';
          if(this.discount_type=="percentage")
          {
          //  this.discount_symbol   = '(- '+ this.discount_price+'%)';
            this.discounted_amount =  (this.payment_amount_before_discount * (this.discount_price) / 100);

            

           //  this.payment_amount_before_discount/this.discount_price ;            
            // console.log(" this.payment_amount  " + this.payment_amount);
          }

          this.payment_amount_after_discount = (this.payment_amount_before_discount - (this.discounted_amount )).toFixed(2);          
        //  console.log(" this.payment_amount_after_discount : " + this.payment_amount_after_discount + " this.payment_amount. : " + this.payment_amount);
         
          // if(parseFloat(this.payment_amount_after_discount)>0)
          // {
            if(this.payment_amount_after_discount<=0&&this.discount_type!="free")
            {
              this.promocodeId  = '';
              this.discount_type = '';
              this.discount_price  = '';
              this.discounted_amount = '';
              this.invalidPromocode = true;
              this.invalidPromocodeMsg = 'Invalid Promo code';
              return false; 
            }
          // }
            this.discounted_amount = parseFloat(this.discounted_amount).toFixed(2);
            this.promocodeApplied = true;
            
            if(this.discount_type=="free")
            {
              this.payment_amount_after_discount = 0;
              this.discounted_amount = parseFloat(this.payment_amount_before_discount).toFixed(2);
            }

            // console.log(" this.discounted_amount : " + this.discounted_amount);

            this.payment_amount = this.payment_amount_after_discount;
            this._cd.detectChanges();
        }
      )
    }

    // console.log(" this.promoCode  " + this.promoCode);
  }

  promocodekeyup(value)
  {  
    this.payment_amount = this.payment_amount_before_discount;
    this.promocodeApplied   = false;
    if(this.promoCode!='')
    {
      this.invalidPromocode = false;
    }   
    if(((this.promoCode).trim()).length>=3)
    {
      this.greyText = '';      
    }
    else
    { 
      this.greyText = 'grey-text disabled';    
    }
    this._cd.detectChanges();
    this.promoCode = value;
  }

  removePromo()
  {
    this.promoCode = '';   
    this.promocodeApplied = false;
    this.payment_amount = this.payment_amount_before_discount;
    this.discounted_amount = '';
  }

  getPromocodeList()
  {
    var promise = new Promise((resolve, reject) => {
      this.apirequest = [];
      this.apirequest["widget_token"] = this.widget_token;
  
      let report_input = this.appservices.generteJSONFromArray(this.apirequest);
      this.appservices.callJSONAPI(this.appservices.PRACTICE_PROMOCODES, report_input, 'post', this, '').subscribe(
        (data: any) => {
          // console.log(" inner data : " + data);
          if(data.status)
          this.availablePromocodes = data;

        //  console.log(" inner data : " + this.availablePromocodes);

          resolve(data);
        }
      ) 
    });
    return promise;
  }

}
